/**
 * Mock data pre profily používateľov (podľa role)
 */

import { officials, ovmIds } from "./officials";

// Profil administrátora
export const adminProfile = {
  id: "profile-admin",
  firstName: "Admin",
  lastName: "Systémový",
  email: "admin@msp.justice.cz",
  phone: "+420221997111",
  role: { name: "ADMIN", displayName: "Administrátor" },
  ovmId: null,
  ovmName: null,
  permissions: [
    "VIEW_ALL",
    "EDIT_ALL",
    "DELETE_ALL",
    "MANAGE_USERS",
    "MANAGE_OVMS",
    "MANAGE_DICTIONARIES",
    "VIEW_STATISTICS",
    "EXPORT_DATA",
  ],
  lastLogin: "2026-02-04T09:00:00.000Z",
};

// Profil evidenčného orgánu
export const eoProfile = {
  id: "profile-eo",
  firstName: "Jana",
  lastName: "Evidenční",
  email: "jana.evidencni@mfcr.cz",
  phone: "+420257042222",
  role: { name: "EO", displayName: "Evidenční orgán" },
  ovmId: ovmIds.ministerstvo,
  ovmName: "Ministerstvo financí",
  permissions: [
    "VIEW_OVM_OFFICIALS",
    "EDIT_OVM_OFFICIALS",
    "VIEW_OVM_STATEMENTS",
    "EDIT_OVM_STATEMENTS",
    "VIEW_OVM_REQUESTS",
    "PROCESS_REQUESTS",
    "VIEW_OVM_INITIATIVES",
    "PROCESS_INITIATIVES",
    "EXPORT_OVM_DATA",
  ],
  lastLogin: "2026-02-04T08:30:00.000Z",
};

// Profil tajemníka
export const tajemnikProfile = {
  id: "profile-tajemnik",
  firstName: "Martin",
  lastName: "Tajemník",
  email: "martin.tajemnik@mfcr.cz",
  phone: "+420257042333",
  role: { name: "TAJEMNIK", displayName: "Tajemník" },
  ovmId: ovmIds.ministerstvo,
  ovmName: "Ministerstvo financí",
  permissions: [
    "VIEW_OVM_OFFICIALS",
    "EDIT_OVM_OFFICIALS",
    "DELETE_OVM_OFFICIALS",
    "VIEW_OVM_STATEMENTS",
    "APPROVE_STATEMENTS",
    "VIEW_OVM_REQUESTS",
    "APPROVE_REQUESTS",
    "VIEW_OVM_INITIATIVES",
    "CLOSE_INITIATIVES",
    "VIEW_OVM_STATISTICS",
    "EXPORT_OVM_DATA",
    "MANAGE_OVM_USERS",
  ],
  lastLogin: "2026-02-03T16:45:00.000Z",
};

// Profil verejného funkcionára (na základe officials[0])
export const vfProfile = {
  id: "profile-vf",
  firstName: officials[0].firstName,
  lastName: officials[0].lastName,
  titleBefore: officials[0].titleBefore,
  titleAfter: officials[0].titleAfter,
  email: officials[0].email,
  phone: officials[0].phone,
  role: { name: "VF", displayName: "Veřejný funkcionář" },
  ovmId: officials[0].ovmId,
  ovmName: officials[0].ovmName,
  officialId: officials[0].id,
  functionType: officials[0].functionType,
  permissions: [
    "VIEW_OWN_PROFILE",
    "EDIT_OWN_PROFILE",
    "VIEW_OWN_STATEMENTS",
    "CREATE_STATEMENT",
    "EDIT_OWN_STATEMENT",
    "VIEW_OWN_REQUESTS",
  ],
  lastLogin: "2026-02-04T07:15:00.000Z",
};

// Profil verejnosti
export const publicProfile = {
  id: "profile-public",
  firstName: "Veřejnost",
  lastName: "",
  email: null,
  phone: null,
  role: { name: "PUBLIC", displayName: "Veřejnost" },
  ovmId: null,
  ovmName: null,
  permissions: [
    "VIEW_PUBLIC_STATEMENTS",
    "CREATE_REQUEST",
    "CREATE_INITIATIVE",
  ],
  lastLogin: null,
  isAnonymous: true,
};

// Super Admin profil - plný prístup na všetko (pre dev/testing)
export const superAdminProfile = {
  id: "profile-super-admin",
  firstName: "Super",
  lastName: "Admin",
  email: "superadmin@dev.local",
  phone: "+420000000000",
  role: { name: "SUPER_ADMIN", displayName: "Super Administrátor" },
  ovmId: null,
  ovmName: null,
  permissions: [
    "*",
    "VIEW_ALL",
    "EDIT_ALL",
    "DELETE_ALL",
    "MANAGE_USERS",
    "MANAGE_OVMS",
    "MANAGE_DICTIONARIES",
    "VIEW_STATISTICS",
    "EXPORT_DATA",
    "VIEW_OVM_OFFICIALS",
    "EDIT_OVM_OFFICIALS",
    "VIEW_OVM_STATEMENTS",
    "EDIT_OVM_STATEMENTS",
    "VIEW_OVM_REQUESTS",
    "PROCESS_REQUESTS",
    "VIEW_OVM_INITIATIVES",
    "PROCESS_INITIATIVES",
    "EXPORT_OVM_DATA",
    "DELETE_OVM_OFFICIALS",
    "APPROVE_STATEMENTS",
    "APPROVE_REQUESTS",
    "CLOSE_INITIATIVES",
    "VIEW_OVM_STATISTICS",
    "MANAGE_OVM_USERS",
    "VIEW_OWN_PROFILE",
    "EDIT_OWN_PROFILE",
    "VIEW_OWN_STATEMENTS",
    "CREATE_STATEMENT",
    "EDIT_OWN_STATEMENT",
    "VIEW_OWN_REQUESTS",
    "VIEW_PUBLIC_STATEMENTS",
    "CREATE_REQUEST",
    "CREATE_INITIATIVE",
  ],
  lastLogin: new Date().toISOString(),
  isDev: true,
};

// Všetky profily pre jednoduché prepínanie
export const profiles = {
  admin: adminProfile,
  eo: eoProfile,
  tajemnik: tajemnikProfile,
  vf: vfProfile,
  public: publicProfile,
  superadmin: superAdminProfile,
};

// Funkcia pre získanie profilu podľa role
export const getProfileByRole = (role) => {
  return profiles[role] || publicProfile;
};

export default profiles;
